(function () {
  var SECTION_SELECTORS = [
    {
      section: '.maison-announcement',
      items: ['.maison-announcement__message']
    },
    {
      section: '.maison-pdp-hero',
      scale: ['.maison-pdp-hero__gallery-wrap', '.maison-pdp-hero__returns img'],
      items: [
        '.maison-pdp-hero__gallery-wrap',
        '.maison-pdp-hero__certs',
        '.maison-pdp-hero__intro',
        '.maison-pdp-hero__clinician',
        '.maison-pdp-hero__benefit',
        '.maison-pdp-hero__offer-heading',
        '.maison-pdp-hero__offer',
        '.maison-pdp-hero__shipping',
        '.maison-pdp-hero__form-wrap',
        '.maison-pdp-hero__payments',
        '.maison-pdp-hero__trust-point',
        '.maison-pdp-hero__returns',
        '.maison-pdp-hero__faq',
        '.maison-pdp-hero__buy-once'
      ]
    },
    {
      section: '.maison-benefits',
      scale: ['.maison-benefits__image-wrap'],
      items: ['.maison-benefits__heading', '.maison-benefits__image-wrap', '.maison-benefits__item']
    },
    {
      section: '.maison-reviews',
      scale: ['.maison-reviews__choice-art', '.maison-reviews__proof'],
      items: [
        '.maison-reviews__tag',
        '.maison-reviews__heading',
        '.maison-reviews__item',
        '.maison-reviews__proof',
        '.maison-reviews__actions'
      ]
    },
    {
      section: '.maison-real-cause',
      scale: ['.maison-real-cause__image-wrap'],
      items: [
        '.maison-real-cause__tag',
        '.maison-real-cause__heading',
        '.maison-real-cause__intro',
        '.maison-real-cause__copy',
        '.maison-real-cause__image-wrap',
        '.maison-real-cause__cause',
        '.maison-real-cause__closing'
      ]
    },
    {
      section: '.maison-medication',
      scale: ['.maison-medication__image-wrap'],
      items: [
        '.maison-medication__image-wrap',
        '.maison-medication__tag',
        '.maison-medication__heading',
        '.maison-medication__copy',
        '.maison-medication__side-effects'
      ]
    },
    {
      section: '.maison-stats',
      scale: ['.maison-stats__card', '.maison-stats__guarantee'],
      items: [
        '.maison-stats__tag',
        '.maison-stats__heading',
        '.maison-stats__description',
        '.maison-stats__card',
        '.maison-stats__guarantee',
        '.maison-stats__actions',
        '.maison-stats__footnote'
      ]
    },
    {
      section: '.maison-ingredients',
      scale: ['.maison-ingredients__image-wrap', '.maison-ingredients__card', '.maison-ingredients__how-to'],
      items: [
        '.maison-ingredients__tag',
        '.maison-ingredients__heading',
        '.maison-ingredients__paragraph',
        '.maison-ingredients__strong-copy',
        '.maison-ingredients__image-wrap',
        '.maison-ingredients__card',
        '.maison-ingredients__button',
        '.maison-ingredients__how-to',
        '.maison-ingredients__footer-note'
      ]
    },
    {
      section: '.maison-life',
      scale: ['.maison-life__icon'],
      items: ['.maison-life__tag', '.maison-life__heading', '.maison-life__intro', '.maison-life__item']
    },
    {
      section: '.maison-timeline',
      scale: ['.maison-timeline__media'],
      items: [
        '.maison-timeline__tag',
        '.maison-timeline__heading',
        '.maison-timeline__intro',
        '.maison-timeline__media',
        '.maison-timeline__line-wrap',
        '.maison-timeline__step'
      ]
    },
    {
      section: '.maison-comparison',
      scale: ['.maison-comparison__product'],
      items: [
        '.maison-comparison__tag',
        '.maison-comparison__heading',
        '.maison-comparison__description',
        '.maison-comparison__product',
        '.maison-comparison__header-row',
        '.maison-comparison__row',
        '.maison-comparison__footer-note'
      ]
    },
    {
      section: '.maison-healthcare',
      scale: ['.maison-healthcare__image-panel'],
      items: [
        '.maison-healthcare__image-panel',
        '.maison-healthcare__content-panel',
        '.maison-healthcare__tag',
        '.maison-healthcare__heading',
        '.maison-healthcare__body',
        '.maison-healthcare__button-wrap'
      ]
    },
    {
      section: '.maison-money-back',
      scale: ['.maison-money-back__badge'],
      items: [
        '.maison-money-back__badge',
        '.maison-money-back__heading',
        '.maison-money-back__body',
        '.maison-money-back__description',
        '.maison-money-back__closing'
      ]
    },
    {
      section: '.maison-offer',
      scale: ['.maison-offer__image', '.maison-offer__offer'],
      items: [
        '.maison-offer__intro',
        '.maison-offer__image',
        '.maison-offer__offer-heading',
        '.maison-offer__offer',
        '.maison-offer__shipping',
        '.maison-offer__form-wrap',
        '.maison-offer__payments-wrap',
        '.maison-offer__trust-point',
        '.maison-offer__buy-once'
      ]
    },
    {
      section: '.maison-faq',
      items: ['.maison-faq__tag', '.maison-faq__heading', '.maison-faq__item']
    },
    {
      section: '.maison-store-benefits',
      scale: ['.maison-store-benefits__icon'],
      items: ['.maison-store-benefits__item']
    },
    {
      section: '.maison-footer',
      items: [
        '.maison-footer__logo',
        '.maison-footer__detail',
        '.maison-footer__disclaimer',
        '.maison-footer__accordion'
      ]
    }
  ];

  var itemClass = 'maison-motion-item';
  var scaleClass = 'maison-motion-scale';
  var visibleClass = 'is-visible';
  var completeClass = 'maison-motion-complete';
  var observer = null;
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function matchesAny(element, selectors) {
    var i;
    if (!selectors || !selectors.length) return false;

    for (i = 0; i < selectors.length; i += 1) {
      if (element.matches(selectors[i])) return true;
    }

    return false;
  }

  function uniqueElements(root, selectors) {
    var seen = [];
    var elements = [];

    selectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (element) {
        if (seen.indexOf(element) !== -1) return;
        seen.push(element);
        elements.push(element);
      });
    });

    return elements;
  }

  function reveal(element) {
    element.classList.add(visibleClass);
    window.setTimeout(function () {
      element.classList.add(completeClass);
    }, 650);
  }

  function getObserver() {
    if (reduceMotionQuery.matches || !('IntersectionObserver' in window)) return null;

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      });
    }

    return observer;
  }

  function prepareSection(section, config) {
    var sectionObserver = getObserver();

    uniqueElements(section, config.items || []).forEach(function (element, index) {
      if (element.dataset.maisonMotionBound === 'true') return;

      element.dataset.maisonMotionBound = 'true';
      element.classList.add(itemClass);
      element.style.setProperty('--maison-motion-delay', Math.min(index * 50, 300) + 'ms');

      if (matchesAny(element, config.scale)) {
        element.classList.add(scaleClass);
      }

      if (!sectionObserver) {
        reveal(element);
        return;
      }

      sectionObserver.observe(element);
    });
  }

  function getSections(root, selector) {
    var sections = [];

    if (root.matches && root.matches(selector)) {
      sections.push(root);
    }

    root.querySelectorAll(selector).forEach(function (section) {
      if (sections.indexOf(section) === -1) {
        sections.push(section);
      }
    });

    return sections;
  }

  function initMaisonMotion(container) {
    var root = container || document;

    SECTION_SELECTORS.forEach(function (config) {
      getSections(root, config.section).forEach(function (section) {
        prepareSection(section, config);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMaisonMotion(document);
    });
  } else {
    initMaisonMotion(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMaisonMotion(event.target || document);
  });
}());
